import { Component } from 'react';

/**
 * Error Boundary component to catch and handle React errors
 * This prevents the entire application from crashing when an error occurs
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI when an error occurs
      return (
        <div className="error-boundary p-4 text-center">
          <div className="card shadow border-danger">
            <div className="card-header bg-danger text-white">
              <h2>Something went wrong</h2>
            </div>
            <div className="card-body">
              <p>The application encountered an error. Please try refreshing the page.</p>
              {this.state.error && (
                <div className="alert alert-secondary">
                  <p><strong>Error:</strong> {this.state.error.toString()}</p>
                </div>
              )}
              <button
                className="btn btn-primary mt-3"
                onClick={() => window.location.reload()}
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    // When there's no error, render children normally
    return this.props.children;
  }
}

// Export the component as default
export default ErrorBoundary;
